export default __webpack_public_path__ + "1d3a980aabc9940160f843f6ec053ed3.svg";